// Storage key for a pending OAuth authorization request. The request params
// are persisted so they survive full-page redirects during login (e.g. Clever).
export const OAUTH_AUTHORIZE_REQUEST_KEY = 'oauthAuthorizeRequest';

export interface OauthAuthorizeRequest {
  client_id: string;
  redirect_uri: string;
  code_challenge: string;
  code_challenge_method: string;
  state?: string;
  scope?: string;
}
